import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";

interface branch{
    id:string,
    pw:string,
    owner_name:string,
    owner_tel:string,
    address:string,
    address_detail:string,
    report_permission:{
        word:false,
        sentence:false,
        video:false,
    }
    name:string,
    tel:string,
}

const useBranchInfo = (branch_id:string) => {
    const {readFirestoreOneDoc, readFirestoreWithQuery} = useFirestore();
    const [studentCount, setStudentCount] = useState(0);
    const [teacherCount, setTeacherCount] = useState(0);
    const [branch, setBranch] = useState<branch>({
        id:"",
        pw:"",
        owner_tel:"",
        owner_name:"",
        address:"",
        address_detail:"",
        report_permission:{
            word:false,
            sentence:false,
            video:false,
        },
        name:"",
        tel:"",
    });

    useEffect(() => {
        if(branch_id){
            getData();
            
        }
        // eslint-disable-next-line
    }, [branch_id])

    const getData = async() => {
        readFirestoreOneDoc("User/Auth/Branch", branch_id).then(res => {
            if(res.exists()){
                const data = res.data();
                setBranch({
                    id:data.id,
                    pw:data.pw,
                    owner_tel:data.owner_tel,
                    owner_name:data.owner_name,
                    address:data.address,
                    address_detail:data.address_detail,
                    report_permission:data.report_permission,
                    name:data.name,
                    tel:data.tel
                })
            }
        })
        getStudentCount();
        getTeacherCount();
    }

    const getStudentCount = async() => {
        const student_count = await readFirestoreWithQuery("User/Auth/Student", {field:"branch_id", operator:"==", data:branch_id}).then(res => {
            if(!res.empty){
                return res.docs.length;
            }
            return 0;
        })
        setStudentCount(student_count);
    }

    const getTeacherCount = async() => {
        const teacher_count = await readFirestoreWithQuery("User/Auth/Teacher", {field:"branch_id", operator:"==", data:branch_id}).then(res => {
            if(!res.empty){
                return res.docs.length;
            }
            return 0;
        })
        setTeacherCount(teacher_count);
    }

    const onRefreshClick = () => {
        if(branch_id){
            getData();
        }
    }

    return {branch, studentCount, teacherCount, onRefreshClick};
}

export default useBranchInfo;